module.exports = __webpack_public_path__ + "static/media/71xMjwoZLaL._SL1500_.420d08e7.jpg";